module.exports = __webpack_public_path__ + "media/images/flags/64/Lithuania-117719078e883ca6e830c43ac89540ba.png";